<script>
    export let project;
    console.log(project)
    let beforeVal=undefined;
    $:{
        if(beforeVal!==project){
            changeProject(project)
            beforeVal=project;
            project=project;
        }
    }
    let projects=[];
    import {apiUrl} from '../config.svelte';
    import {Input} from 'sveltestrap';
    import { Router,  Route } from "svelte-routing";
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    import {onMount,onDestroy} from 'svelte';
    function changeProject(p){
        dispatch("change",{value:p})
    }
    onMount(()=>{
        fetch(apiUrl+"info",{
            method:"POST",
            body:JSON.stringify({method:"projects"}),
            cors:'no-cors',
            credentials:'include',
        })
        .then(x=>x.json())
        .then(x=>{
            if(x.result){
                projects=[]
                x.data.forEach(element => {
                    if(project&&project.Project==element.Project){
                        projects.push(project)
                    }else{
                        projects.push(element)
                    }
                });
            }else{
                projects=[]  
            }
        })
    })
</script>
<Input type="select" id="project-input" bind:value={project} >
    <option value={undefined}>проект...</option>
    {#each projects as proj}
        <option selected={project==proj?true:false} value={proj}>{proj.Project}</option>
    {/each}
</Input>
